// Import: Middleware Action & Custom Types
import { CLEAN_INCODE_STATUS, CLEAN_INCODE_STATUS_ERROR } from '_models/redux/types';

// Action function
export const cleanIncodeStatus = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_INCODE_STATUS,
    });
  } catch (e) {
    dispatch({
      payload: undefined,
      type: CLEAN_INCODE_STATUS_ERROR,
    });
  }
};
